<template>
    <v-container>
      <v-list-item key="account" to="/account">
        <v-list-item-icon>
          <v-icon>mdi-account-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Manage your account</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item key="favourites" to="/favourites">
        <v-list-item-icon>
          <v-icon>mdi-heart</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>View your favourites</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item key="share"
        v-clipboard="landingpageUrl"
        @click="snackbar = true">
        <v-list-item-icon>
          <v-icon
          color="pink">mdi-emoticon-kiss-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Share this app</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-row>
        <v-divider/>
      </v-row>

      <v-list two-line>
        <template v-for="(item) in appState.persons">
          <v-list-item
            :key="item.id"
            :to="'person/' + item.id"
          >

          <v-list-item-avatar>
            <v-avatar
              color="blue"
            >
              <div class="white--text body-2" style="text-align: center">{{ getInitials(item.name) }}</div>
            </v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.type }}</v-list-item-subtitle>
          </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <v-container v-if="appState.persons.length === 0" fill-height fluid>
        <v-row justify="center">
            <v-col align="center" justify="center">
              <h1 class="display-1 font-weight-thin mb-2">
                Tap +  to add your first creative!
              </h1>
            </v-col>
        </v-row>
      </v-container>

      <v-snackbar
        v-model="snackbar"
        centered
      >
        {{ snackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            OK
          </v-btn>
        </template>
      </v-snackbar>

    </v-container>
</template>

<script>
export default {
  data() {
    return {
      landingpageUrl: 'https://exposed-7a994.web.app/',
      snackbar: false,
      snackbarText: 'Copied link to clipboard!',
      appState: this.$root.$data.appStore.state,
    };
  },
  methods: {
    getInitials(name) {
      return name.split(' ').reduce((acc, str) => acc.length < 2 ? '' + acc + str.charAt(0) : acc, '').toUpperCase();
    }
  },
};
</script>
